import { render, staticRenderFns } from "./StorageItem.vue?vue&type=template&id=36afce6a&scoped=true&"
import script from "./StorageItem.vue?vue&type=script&lang=js&"
export * from "./StorageItem.vue?vue&type=script&lang=js&"
import style0 from "./StorageItem.vue?vue&type=style&index=0&id=36afce6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36afce6a",
  null
  
)

export default component.exports